import * as GenderStoreActions from './gender.actions';
import * as GenderStoreSelectors from './gender.selectors';
import * as GenderStoreReducer from './gender.reducer';

export { GenderStoreActions, GenderStoreSelectors, GenderStoreReducer };
